import AbstractService from '~/composables/analytics/services/AbstractService'
import type ProductImpressionData from '~/types/analytics/marketplace/ProductImpressionData'
import pushToCriteoQueue from '~/utils/thirdPartyTrackers/Criteo/pushToCriteoQueue'
import type ProductViewData from '~/types/analytics/marketplace/ProductViewData'
import type ProductAddedToCartData from '~/types/analytics/marketplace/ProductAddedToCartData'
import type CartViewData from '~/types/analytics/marketplace/CartViewData'
import type PayButtonClickedData from '~/types/analytics/marketplace/PayButtonClickedData'

export default class extends AbstractService {
  trackMarketplaceProductImpressions(impressions: ProductImpressionData[]): void {
    const productSKUs = impressions.map((predicate) => predicate.sku)

    pushToCriteoQueue({ event: 'viewList', item: productSKUs })
  }

  trackMarketplaceProductView(data: ProductViewData) {
    pushToCriteoQueue({
      event: 'viewItem',
      item: [data.sku],
    })
  }

  trackMarketplaceProductAddedToCart(data: ProductAddedToCartData) {
    pushToCriteoQueue({
      event: 'addToCart',
      item: [{ id: data.sku, price: data.price, quantity: data.quantity }],
    })
  }

  trackViewCart(data: CartViewData) {
    pushToCriteoQueue({
      event: 'viewBasket',
      item: data.items.map((predicate) => {
        return { id: predicate.sku, price: predicate.price, quantity: predicate.quantity }
      }),
    })
  }

  trackMarketplacePayButtonClick(data: PayButtonClickedData) {
    pushToCriteoQueue({
      event: 'trackTransaction',
      id: `qu${data.quoteId}`,
      item: [
        data.items.map((product) => {
          return {
            id: product.sku,
            price: product.price,
            quantity: product.quantity,
          }
        }),
      ],
    })
  }
}
